import TopNavBar from "../../components/reusables/topNavBar";
import CustomerTable from "./components/customerTable";

function Customers() {
  return (
    <div className='h-full flex flex-col'>
      <TopNavBar title={"Clientes"} subtitle={"Gerencie os seus clientes."} />
      <div className='mx-4 sm:mx-10 my-6 flex-1 font-poppins text-custom_lighter_gray_font'>
        <CustomerTable />
      </div>
    </div>
  )
}

export default Customers